package org.hs_soft.runmynesto.pages.home.sub_page.user.component.tabs.general_tab

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.padding
import org.hs_soft.runmynesto.domain.config.Dimen

import org.hs_soft.runmynesto.domain.config.Theme
import org.hs_soft.runmynesto.domain.config.autoResponsiveness
import org.hs_soft.runmynesto.domain.model.general.WindowSizeModeEnum
import org.hs_soft.runmynesto.domain.model.home.user.single_user.GetUser
import org.hs_soft.runmynesto.domain.util.helper.Strings
import org.hs_soft.runmynesto.domain.util.openLocalForSelectingFile
import org.hs_soft.runmynesto.pages.components.MediumContentTitle
import org.hs_soft.runmynesto.pages.components.UploadImage
import org.jetbrains.compose.web.css.LineStyle

@Composable
fun UserTabContent(
    windowSizeMode: WindowSizeModeEnum,
    selectedUser: GetUser?,
    imgUrl: String?,
    userInfoDetailPasswordVisibility: Boolean,
    onUserInfoDetailPassEyeClick: () -> Unit,
    updateNameValue: (String) -> Unit,
    updatePrintNameValue: (String) -> Unit,
    updateShortNameValue: (String) -> Unit,
    updatePasswordValue: (String) -> Unit,
    updateActivity: (Boolean) -> Unit,
    onSelectImage: (String) -> Unit,
) {

    Row(
        modifier = Modifier
            .fillMaxHeight()
            .autoResponsiveness()
            .fillMaxWidth()
            .padding(
                bottom =  Dimen.extraLargePadding,
                top = Dimen.largePadding,
                leftRight = Dimen.extraLargePadding
            )
            .borderRadius(Dimen.semiLargeRadius)
            .border(
                width = Dimen.smallThickness,
                style = LineStyle.Solid,
                color = Theme.ActionDisabledBackground.rgb
            )
    )
    {
        Column(modifier = Modifier.margin(right = Dimen.largePadding))
        {

            MediumContentTitle(
                title = Strings.current().general,
            )

            UserInfoDetail(
                name = selectedUser?.name ?: "",
                printName = selectedUser?.printName ?: "",
                password = selectedUser?.password ?: "",
                isActive = selectedUser?.isActive?:false,
                passwordVisible = userInfoDetailPasswordVisibility,
                shortName = selectedUser?.shortName ?: "",
                onVisiblePassClick = {
                    onUserInfoDetailPassEyeClick()
                },
                updateNameValue = {
                    updateNameValue(it)
                },
                updatePrintNameValue = {
                    updatePrintNameValue(it)
                },
                updateShortNameValue = {
                    updateShortNameValue(it)
                },
                updatePasswordValue = {
                    updatePasswordValue(it)
                },
                updateActivityValue = {
                    updateActivity(it)
                },
            )
        }

        Column(
            modifier = Modifier ,
            horizontalAlignment = Alignment.CenterHorizontally,
        )
        {
            MediumContentTitle(
                title = Strings.current().userPhoto,
                marginBottom = Dimen.mediumPadding,
            )

            UploadImage(
                width = Dimen.selectCirclePhotoSize,
                height = Dimen.selectCirclePhotoSize,
                imgUrl = imgUrl,
                setImageDirectlyStatus = true,
                circleShape = true,
                onImgContentClick = {
                    openLocalForSelectingFile()
                },
                setImageDirectly ={
                    onSelectImage(it)
                },
            )


        }

    }



}


